import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import { getAllInspectionDisciplines, getAllReportGroups, getReportDetails } from 'redux/pages/Manage/InspectionSettings/Reports/ReportsSlice';



const textEditor = (options) => {
    return <InputText type="text" maxLength={options.field==="reportName"? 100 : 150} value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
};

const statusLookup = [
    { name: "Active", key: "Active" },
    { name: "Inactive", key: "Inactive"}];

const fields = [
    { name: 'Field1', id: 1 },
    { name: 'Field2', id: 2 },
    { name: 'Field3', id: 3 },
    { name: 'Field4', id: 4 }
];

const fields1 = [
    { name: 'Field1', id: 1 },
    { name: 'Field2', id: 2 },
    
];


interface Props {
    getTableColumns: (data: any) => void,
}


const ParentData : React.FC<Props> = ({
    getTableColumns = () => { },
}) => {

    const inspectionDisciplineData = useAppSelector((state) => state.report.inspectionDisciplineData);
    const reportGroupsData = useAppSelector((state) => state.report.reportGroupsData);
    const reportDetails = useAppSelector((state) => state.report.reportDetails);
    const [disciplineLookup, setDisciplineLookup] = useState([])
    const [reportGroupLookup, setReportGroupLookup] = useState([]);
    const dispatch = useDispatch<any>()


    useEffect(() => {
        dispatch(getAllInspectionDisciplines())
		dispatch(getAllReportGroups())
        
    }, [dispatch])

    useEffect(() => {
        
        if (reportGroupLookup.length > 0 && disciplineLookup.length > 0) {
            getTableColumns(INSPECTION_REPORTS_COLS);
        }
    }, [ reportGroupLookup, disciplineLookup]);
        

    useEffect(() => {
        if (reportGroupsData) {
          const reportGroup = reportGroupsData.map((item: any) => ({
            name: item.reportGroupName,
            code: item.reportGroupId,
          }));
          setReportGroupLookup(reportGroup);
        }
      }, [reportGroupsData]);

    const DropdownsData  = (options:any) => {
    
        return (
        <Dropdown
          value={options.value}
          options={reportGroupLookup}
          optionLabel="name" 
          optionValue="name" 
          onChange={(e) => options.editorCallback(e.value)} 
        />
      );
    }

    const StatusDropdown  = (options:any) => {
        return (
          <Dropdown
            value={options.value}
            options={statusLookup}
            optionLabel="name" 
            optionValue="name" 
            onChange={(e) => options.editorCallback(e.value)} 
          />
        );
      }

    const MultiSelectEditor  = (options) => {
        if((typeof options.value) === "string")
            options.value = options.value.trim() === "" ? [] : options.value.split(",");

          return (
                <div className='main-multiselect-wrapper'>
                <MultiSelect
                inputId="reportGroup"
                {...options}
                value={options.value}
                onChange={(e) => options.editorCallback(e.value)}
                options={disciplineLookup}
                optionLabel="disciplineName"
                optionValue='disciplineName'
                placeholder="Select Discipline"
                filter 
            />
            </div>
                    
            );
        }
    
    
    useEffect(() => {
        if (inspectionDisciplineData?.length > 0) {         
            let disciplineList: any = [];
            inspectionDisciplineData.map((item: any) => {
                return disciplineList.push({ disciplineId
                    : item.disciplineId, disciplineName: item.disciplineName })
            })
            setDisciplineLookup(disciplineList)
        }
    }, [inspectionDisciplineData])
  

     const INSPECTION_REPORTS_COLS = {
        REPORTS_COLS: [
            {
                field: 'reportName',
                header: 'Report Name',
                editor: (options) => textEditor(options),
                style: { flex: '1 0 200px' },
                sortable: true,
            },
            {
                field: 'reportTitle',
                header: 'Report Title',
                editor: (options) => textEditor(options),
                style: { flex: '1 0 200px' },
                sortable: true,
            },
            {
                field: 'reportGroup',
                header: 'Report Group',
                editor: (options) => DropdownsData(options),
                style: { flex: '1 0 200px' },
                sortable: true,
            },        
            {
                field: 'reportStatus',
                header: 'Report Status',
                editor: (options) => StatusDropdown(options),
                style: { flex: '1 0 200px' },
                sortable: true,
            },
            {
                field: 'inspectionDisciplines',
                header: 'Inspection Discipline',
                editor: (options) => MultiSelectEditor(options),
                style: { flex: '1 0 200px' },
                sortable: true,
            }
        ]
        
    };
  
  return (
        <></>
            
    );
}



export default ParentData




export const INSPECTION_REPORTS_ROWS = {
    REPORTS_ROWS: [
        {
            id: 1,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 2,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 3,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 4,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 5,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 6,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 7,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 8,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 9,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 10,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 11,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 12,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 13,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 14,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 15,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 16,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 17,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 18,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 19,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        },
        {
            id: 20,
            reportName: 'NFPA10 Annual Portable Extingushers',
            reportTitle: 'NFPA10 Annual Portable Extingushers',
            reportGroup: 'NFPA Reports'
        }
    ]
}